export default "__VITE_ASSET__ad15f9ce__"